import { Component } from "@angular/core";
import { ProgressSpinner } from "primeng/progressspinner";

@Component({
    templateUrl: './oidc-redirect.component.html',
    imports: [
        ProgressSpinner,
    ]
})
export class OidcRedirectComponent {
}